mutation UploadMediaFiles($clientId: ID!, $folderId: ID!, $files: [InputMediaFileUpload]!) {
    uploadMediaFiles(clientId: $clientId, folderId: $folderId, files: $files) {
        id
    }
}
